// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"ed1303e3","611":"0952abed","761":"618d0046","947":"a611f495"}[chunkId] + ".chunk.js";
};